import { INVENTORY_LOT_STATUS_TO_LABEL, INVENTORY_STATUS_TO_LABEL } from "./constants"

import type { GoodsReceiptPalletRowLot, InventoryByLotStatus, InventoryStatus } from "@/graphql/codegen/graphql"

export const getInventoryStatusLabel = (status: InventoryStatus): string => INVENTORY_STATUS_TO_LABEL[status] ?? status

export const getInventoryLotStatusLabel = (status: InventoryByLotStatus): string =>
  INVENTORY_LOT_STATUS_TO_LABEL[status] ?? status

export const getInventoryLotKey = (lot: Pick<GoodsReceiptPalletRowLot, "lotNumber" | "batchNumber">): string =>
  `${lot.lotNumber}-${lot.batchNumber}`
